export function customEncodeUrlParam(param: string): string {
  const map: { [key: string]: string } = {
    À: 'A',
    Á: 'A',
    Â: 'A',
    Ã: 'A',
    Ä: 'A',
    Å: 'A',
    Æ: 'AE',
    Ç: 'C',
    È: 'E',
    É: 'E',
    Ê: 'E',
    Ë: 'E',
    Ì: 'I',
    Í: 'I',
    Î: 'I',
    Ï: 'I',
    Ð: 'D',
    Ñ: 'N',
    Ò: 'O',
    Ó: 'O',
    Ô: 'O',
    Õ: 'O',
    Ö: 'O',
    Ø: 'O',
    Ù: 'U',
    Ú: 'U',
    Û: 'U',
    Ü: 'U',
    Ý: 'Y',
    Þ: 'Th',
    ß: 'ss',
    à: 'a',
    á: 'a',
    â: 'a',
    ã: 'a',
    ä: 'a',
    å: 'a',
    æ: 'ae',
    ç: 'c',
    è: 'e',
    é: 'e',
    ê: 'e',
    ë: 'e',
    ì: 'i',
    í: 'i',
    î: 'i',
    ï: 'i',
    ð: 'd',
    ñ: 'n',
    ò: 'o',
    ó: 'o',
    ô: 'o',
    õ: 'o',
    ö: 'o',
    ø: 'o',
    ù: 'u',
    ú: 'u',
    û: 'u',
    ü: 'u',
    ý: 'y',
    þ: 'th',
    ÿ: 'y',
  }

  let cleanParam = param
    .split('')
    .map((char) => map[char] || char)
    .join('')

  cleanParam = cleanParam.replace(/ /g, '_')
  cleanParam = cleanParam.replace(/\./g, '-')
  cleanParam = cleanParam.replace(/[^a-zA-Z0-9_-]/g, '')

  return cleanParam
}

// const input =
//   '31/05 - TURNÊ SPC ACÚSTICO 2 - ÚLTIMO ENCONTRO JOÃO PESSOA LOUNGE.'
// const encodedParam = customEncodeUrlParam(input)

// console.log(encodedParam)
